module.exports = __webpack_public_path__ + "img/upload_image.016ff408.png";